'use strict';

import { isDefined } from '../../utils/variables';
import cameraManagerInstance from '../camera-manager';
import { InputHandler } from '../input-handler';
import { publish, SubscriptionTopic } from '../messaging/pubsub';
import {
  KeyInputData,
  MouseInputData,
  TouchInputData,
} from '../utilities/input-event/input-event-data-extractor';
import { Tool } from './tool';

export class CameraInputTool extends Tool {
  private cameraMoved: boolean;
  constructor(inputHandler: InputHandler) {
    super('camera', inputHandler);

    this.cameraMoved = false;
  }

  hasCameraMoved(): boolean {
    return this.cameraMoved;
  }

  onTouchStart(touchInputData: TouchInputData): boolean {
    this.setCameraMoved(false);
    const controller = cameraManagerInstance().getActiveController();
    return !!controller && controller.onTouchStart(touchInputData);
  }

  onTouchMove(touchInputData: TouchInputData): boolean {
    const controller = cameraManagerInstance().getActiveController();
    const movedState = isDefined(controller) && controller.onTouchMove(touchInputData);
    this.setCameraMoved(movedState);

    return movedState;
  }

  onTouchEnd(touchInputData: TouchInputData): boolean {
    this.setCameraMoved(false);
    const controller = cameraManagerInstance().getActiveController();
    return !!controller && controller.onTouchEnd(touchInputData);
  }

  onMouseDown(mouseInputData: MouseInputData): boolean {
    this.setCameraMoved(false);
    const controller = cameraManagerInstance().getActiveController();
    return !!controller && controller.onMouseDown(mouseInputData);
  }

  onMouseMove(mouseInputData: MouseInputData): boolean {
    const controller = cameraManagerInstance().getActiveController();
    const movedState = isDefined(controller) && controller.onMouseMove(mouseInputData);
    this.setCameraMoved(movedState);

    return movedState;
  }

  onMouseUp(mouseInputData: MouseInputData): Promise<boolean> {
    this.setCameraMoved(false);
    const controller = cameraManagerInstance().getActiveController();
    return Promise.resolve(!!controller && controller.onMouseUp(mouseInputData));
  }

  onMouseWheel(mouseInputData: MouseInputData): boolean {
    const controller = cameraManagerInstance().getActiveController();
    const movedState = isDefined(controller) && controller.onMouseWheel(mouseInputData);
    this.setCameraMoved(movedState);

    return movedState;
  }

  onKeyDown(keyInputData: KeyInputData) {
    cameraManagerInstance().getActiveController()?.onKeyDown?.(keyInputData);
  }

  onKeyUp(keyInputData?: KeyInputData) {
    if (keyInputData) {
      cameraManagerInstance().getActiveController()?.onKeyUp?.(keyInputData);
    }
  }

  onAnimate() {
    const camera = cameraManagerInstance().getActiveCamera();
    if (cameraManagerInstance().getActiveController()?.update?.() && isDefined(camera)) {
      publish(SubscriptionTopic.OnCameraMoved, { camera });
    }
  }

  setCameraMoved(state: boolean) {
    this.cameraMoved = state;
    const camera = cameraManagerInstance().getActiveCamera();
    if (state && isDefined(camera)) {
      publish(SubscriptionTopic.OnCameraMoved, { camera });
    }
  }
}
